<template>
    <toolbar-option>
        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="speedOptions"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'hamburger-nav-slide-speed';
const DEFAULT_SPEED_INDEX = 2;

export default {
    name: 'hamburger-nav-slide-speed',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Slide In Speed',
            sliderIndex: DEFAULT_SPEED_INDEX,
            speedOptions: [
                0.1,
                0.2,
                0.3,
                0.4,
                0.5,
                0.6,
                0.7,
                0.8,
                0.9,
                1,
                1.25,
                1.5,
                1.75,
                2,
            ],
        };
    },

    computed: {
        speed() {
            return this.speedOptions[this.sliderIndex];
        },
    },

    methods: {
        onInput(sliderIndex) {
            this.sliderIndex = sliderIndex;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.speed);
        },

        onSelectedElement() {
            const speed = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);

            if (speed) {
                this.sliderIndex = this.speedOptions.indexOf(Number(speed));
            } else {
                this.sliderIndex = DEFAULT_SPEED_INDEX;
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.speed, { triggerChangeDetection: false });
            }
        },
    },
};
</script>
